import { DialogContent, TextField, Typography, makeStyles, useTheme } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { ServiceAutocompleteList, ServiceAutocompleteListAsDialog } from 'pages/CustomerBookingCreate/2.3/ServiceDetails/ServiceAutocompleteList';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import ReactJson from 'react-json-view';
import { SelectedServiceList } from './SelectedServiceList';
import { adjustTransactionState } from 'pages/CustomerBooking/RecoilState';
import { useRecoilState } from 'recoil';
import { mapServiceItemsToAdjustTransaction } from 'components/ServiceCard/ServiceCard.types';

const useStyles = makeStyles(theme => ({
}));
const ServiceModifier = ({
  booking,
  promo,
  services,
  open,
  onClose,
  selectedServices: defaultServices = [],
  displayCoverage
}) => {
  const classes = useStyles()
  const [serviceList, setServiceList] = useState([]);
  1
  const [selectedServices, setSelectedServices] = useState(defaultServices);
  const [adjustTransaction, setAdjustTransaction] = useRecoilState(adjustTransactionState);

  const theme = useTheme()
  const renderServiceTypeSelect = useMemo(() => {
    const subHeading = <Typography
      variant="body2"
      color="textSecondary"
      style={{ textAlign: 'center', marginBottom: theme.spacing(2) }}>
      {`Tap one or more service you want to add. Note that if the service is not covered by your Healthcare Provider, you will have to pay for it from your own pocket`}
    </Typography>

    setServiceList(services?.[0])
    // if (services?.length <= 1) {
    //   return subHeading
    // }
    return (
      <>
        {subHeading}
        <Autocomplete
          options={services}
          renderOption={(option, props) => {
            return option?.type?.label
          }}
          getOptionLabel={(option) => {
            return option?.type?.label
          }}
          renderInput={(iParams) => (
            <TextField
              {...iParams}
              InputLabelProps={{
                shrink: true,
              }}
              label={"Select Service Type"}
              variant={"outlined"}
              fullWidth
            />
          )}
          defaultValue={services?.[0]}
          onChange={(evt, option) => {
            setServiceList(option)
          }}

        />

      </>
    )
  }, [services])


  const doClearItem = useCallback(
    (item) => {
      const a = selectedServices.filter((i) => {
        return i?.item?.id !== item?.item?.id
      });
      setSelectedServices(a)
    },
    [selectedServices],
  );

  const doAddItem = useCallback(
    (item) => {
      const a = [...selectedServices, item];
      setSelectedServices(a)
    },
    [selectedServices],
  );

  const modifyAdjustTransaction = useCallback(
    () => {
      const adjustServices = mapServiceItemsToAdjustTransaction({ serviceItems: selectedServices })
      setAdjustTransaction({
        ...adjustTransaction,
        extended_package_items: adjustServices
      })
    },
    [selectedServices, adjustTransaction],
  );
  return (
    <>
      <ServiceAutocompleteListAsDialog
        compact
        displayCoverage={displayCoverage}
        title="Add/Remove Services"
        subHeader={renderServiceTypeSelect}
        service={serviceList}
        open={open}
        onSelect={(services) => {
          setSelectedServices(services)
        }}
        selectedItems={selectedServices}
        onClose={() => onClose()}
        forwardMapping={(service) => {
          return {
            item: service,
            is_adhoc: service?.adhoc_enabled,
            package_id: null,
            showInCart: true,
          }
        }}
        comparator={(a, b) => {
          return a?.item?.id === b?.item?.id
        }}
        // reverseMapping={(service) => {
        //   return service?.item
        // }}
      >
        <SelectedServiceList
          promo={promo}
          booking={booking}
          selectedServices={selectedServices}
          onRemove={(service) => {
            doClearItem(service)
          }}
          onConfirm={() => {
            modifyAdjustTransaction()
          }}
        />
      </ServiceAutocompleteListAsDialog>
    </>
  )
}

export { ServiceModifier }